<template>
	<div>
		<v-container align="center" justify="center" class="pt-5 pb-0">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"><h1>Practice operations</h1></v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-container class="pt-0 mt-0 mb-0">
			<v-form ref="practiceOperationsForm" v-model="valid" lazy-validation class="pl-4 pr-5">
				<v-card-text align="center" justify="center" class="justify-center text-center">
					<v-row
						><v-col>
							<v-list-item-title align="center" justify="justify" class="pb-1 text-wrap"><h2>Open hours</h2></v-list-item-title>
						</v-col></v-row
					>

					<v-row
						><v-col>
							<v-list-item-title align="left" justify="left" class="pb-1 text-wrap"><h3>Weekdays</h3></v-list-item-title>
						</v-col></v-row
					>

					<v-row align="baseline" justify="center">
						<v-col>
							<time-picker-dialog initial="08:00" label="Start time" @input="OnWeekdayStartTimeInput"></time-picker-dialog>
						</v-col>
						<v-col cols="1"
							><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
						>
						<v-col>
							<time-picker-dialog initial="18:00" label="End time" @input="OnWeekdayEndTimeInput"></time-picker-dialog>
						</v-col>
					</v-row>

					<v-row
						><v-col>
							<v-list-item-title align="left" justify="left" class="pb-1 pt-2 text-wrap"><h3>Saturdays</h3></v-list-item-title>
						</v-col></v-row
					>

					<v-row align="baseline" justify="center">
						<v-col>
							<time-picker-dialog initial="09:00" label="Start time" @input="OnSaturdayStartTimeInput"></time-picker-dialog>
						</v-col>
						<v-col cols="1"
							><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
						>
						<v-col>
							<time-picker-dialog initial="13:00" label="End time" @input="OnSaturdayEndTimeInput"></time-picker-dialog>
						</v-col>
					</v-row>

					<v-row
						><v-col class="pb-0 mb-0">
							<v-checkbox v-model="openSunday" :value="openSundayComputed"
								><template #label
									><div>
										<v-list-item-title align="center" justify="center" class="text-wrap"><h3>We are open on Sundays</h3></v-list-item-title>
									</div></template
								></v-checkbox
							>
						</v-col></v-row
					>
					<v-row v-show="openSunday" align="baseline" justify="center">
						<v-col class="pt-0">
							<time-picker-dialog initial="09:00" label="Start time" @input="OnSundayStartTimeInput"></time-picker-dialog>
						</v-col>
						<v-col cols="1"
							><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
						>
						<v-col>
							<time-picker-dialog initial="13:00" label="End time" @input="OnSundayEndTimeInput"></time-picker-dialog>
						</v-col>
					</v-row>

					<v-row
						><v-col class="pb-0 mb-0">
							<v-checkbox v-model="openHoliday"
								><template #label
									><div>
										<v-list-item-title align="center" justify="center" class="text-wrap"><h3>We are open on Public Holidays</h3></v-list-item-title>
									</div></template
								></v-checkbox
							>
						</v-col></v-row
					>
					<v-row v-show="openHoliday" align="baseline" justify="center">
						<v-col class="pt-0">
							<time-picker-dialog initial="09:00" label="Start time" @input="OnHolidayStartTimeInput"></time-picker-dialog>
						</v-col>
						<v-col cols="1"
							><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
						>
						<v-col>
							<time-picker-dialog initial="13:00" label="End time" @input="OnHolidayEndTimeInput"></time-picker-dialog>
						</v-col>
					</v-row>

					<v-row
						><v-col>
							<v-list-item-title class="pt-5 text-center text-wrap"><h2>Systems used</h2></v-list-item-title>
						</v-col></v-row
					>

					<v-row
						><v-col class="pb-0">
							<v-text-field
								v-model="systemsUsed"
								label="Tell us about any specific software/programs that your Locum needs to work with"
								outlined
							></v-text-field> </v-col
					></v-row>

					<v-row align="center" justify="center">
						<v-col align="center" justify="center" :cols="7">
							<DistinctYesNo :initial="professionalInsuranceCover" @input="changeInsuranceCover"
								>Does your Malpractice Insurance cover Locums working in your practice?</DistinctYesNo
							>
						</v-col>
					</v-row>

					<v-row
						><v-col>
							<v-select
								v-model="languagesPreferred"
								label="Enter the preferred languages"
								outlined
								multiple
								chips
								:items="languagesOptions"
								:rules="languagesPreferredRules"
							></v-select> </v-col
					></v-row>
				</v-card-text>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import { bus } from '@/main';
// eslint-disable-next-line
import axios from 'axios';
import store from '@/store';

import timePickerDialog from '@/components/custom/TimePickerDialog.vue';
import DistinctYesNo from '@/components/custom/YesNo.vue';

export default {
	components: {
		timePickerDialog,
		DistinctYesNo,
	},
	data: () => ({
		company: store.getters.company,
		valid: false,
		step: 'operations-step',

		weekdayStartTime: null,
		weekdayEndTime: null,

		saturdayStartTime: null,
		saturdayEndTime: null,

		sundayStartTime: null,
		sundayEndTime: null,

		holidayStartTime: null,
		holidayEndTime: null,

		openSunday: true,
		openHoliday: false,

		systemsUsed: store.getters.company.systemsUsed || '',
		systemsUsedRules: [v => !!v || 'Required'],

		languagesPreferred: store.getters.company?.languages || [],
		languagesPreferredRules: [v => !!v || 'Required', v => (!!v && v.length > 0) || 'Please select at least one language'],
		systemsUsedPreferredRules: [v => !!v || 'Required'],

		postalCodeRules: [v => !!v || 'Required'],
		professionalInsuranceCover: 'professionalInsuranceCover' in store.getters.company ? (store.getters.company.professionalInsuranceCover ? 'yes' : 'no') : 'no',
	}),

	computed: {
		openSundayComputed() {
			return this.openSunday;
		},
		user() {
			return store.getters.user;
		},
		languagesOptions() {
			return store.getters.configs.languages;
		},
	},
	watch: {},

	mounted() {
		window.scrollTo(0, 0);
		bus.$on('intent:submit-forms:operations-step', data => {
			this.postToBackend(data);
		});

		this.$nextTick(() => {
			const extra_hours = Object.keys(this.company.working_hours).find(k => k == 'extra_hours');
			this.openSunday = extra_hours ? this.company.working_hours.extra_hours.sundays : this.openSunday;
			this.openSunday = extra_hours ? this.company.working_hours.extra_hours.public_holidays : this.openHoliday;
		});
	},

	methods: {
		OnWeekdayStartTimeInput(value) {
			this.weekdayStartTime = value;
		},
		OnWeekdayEndTimeInput(value) {
			this.weekdayEndTime = value;
		},

		OnSaturdayStartTimeInput(value) {
			this.saturdayStartTime = value;
		},
		OnSaturdayEndTimeInput(value) {
			this.saturdayEndTime = value;
		},

		OnSundayStartTimeInput(value) {
			this.sundayStartTime = value;
		},
		OnSundayEndTimeInput(value) {
			this.sundayEndTime = value;
		},

		OnHolidayStartTimeInput(value) {
			this.holidayEndTime = value;
		},
		OnHolidayEndTimeInput(value) {
			this.holidayEndTime = value;
		},
		changeInsuranceCover(option) {
			this.professionalInsuranceCover = option;
		},

		validate() {
			return this.$refs.practiceOperationsForm.validate();
		},
		reset() {
			this.$refs.practiceOperationsForm.reset();
		},
		resetValidation() {
			this.$refs.practiceOperationsForm.resetValidation();
		},
		SubmitForm() {
			let valid = this.validate();
			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			}
		},
		checkStep() {
			const company = store.getters.company;
			const { languages, working_hours } = company;
			let fields = ['weekdays', 'saturday'];

			if (languages?.length >= 1 && working_hours && fields.every(key => working_hours[key])) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else if (languages?.length >= 1 && working_hours?.weekdays) {
				return true;
			} else {
				return false;
			}
		},
		async postToBackend() {
			//post to api backend for this form.
			this.validate();

			if (this.languagesPreferred.length > 0) {
				bus.$emit('update:spinning', true);
				const token = store.getters.jwtToken;

				let body = {
					weekdays: {
						start: this.weekdayStartTime,
						end: this.weekdayEndTime,
					},
					saturday: {
						start: this.saturdayStartTime,
						end: this.saturdayEndTime,
					},
					extra_hours: {
						sundays: this.openSunday,
						public_holidays: this.openHoliday,
					},
					languages: this.languagesPreferred,
					systemsUsed: this.systemsUsed,
					professionalInsuranceCover: this.professionalInsuranceCover === 'yes',
				};

				if (this.openSunday) {
					body.sundays = {
						start: this.sundayStartTime,
						end: this.sundayEndTime,
					};
				}
				if (this.openHoliday) {
					body.public_holidays = {
						start: this.holidayStartTime,
						end: this.holidayEndTime,
					};
				}

				//check if the fields have been updated then set button colours
				const { languages, weekdays, saturday /* , systemsUsed */ } = body;
				if (languages?.length >= 1 && weekdays && saturday /*  && systemsUsed?.length >= 3 */) {
					store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				}

				try {
					let response = await axios.put(store.getters.getAPI + '/companies/' + store.getters.company.id + '/operations', body, { headers: { Authorization: token } });
					bus.$emit('form-submitted', { form: this.name, status: response.status });
					if (response.status === 200) {
						store.commit('SET_COMPANY', response.data.data);
						bus.$emit('intent:next-step', 'operations-step');
					}
				} catch (err) {
					console.error(err);
				} finally {
					bus.$emit('update:spinning', false);
				}
			}
		},

		beforeDestroy() {
			bus.$off('intent:submit-forms:operations-step');
			bus.$off('intent:submit-forms:' + +this.name);
		},
	},
};
</script>
